'use client';

import { useEffect, useRef } from 'react';

import { usePathname } from 'next/navigation';

import { initPostHogOnce, trackSpaNavigation } from '@OnArk/utils/posthog';

// App Router counterpart of the legacy usePostHog() in pages/_app.tsx. Until
// this existed, App Router pages (/start/*, /sign-up, v2 /admin) never
// initialized posthog-js at all — every capture() there, including the whole
// signup_trial.* funnel catalog, queued in memory and silently vanished. The
// module-level guard inside initPostHogOnce keeps the two router trees from
// double-initializing (posthog-js 1.372 resets the session on re-init).
//
// Pageviews: init captures the initial one itself (capture_pageview default);
// App Router SPA navigations don't remount this component, so track pathname
// changes manually — skipping the first run to not double-count the initial.
export function AnalyticsProvider() {
  const pathname = usePathname();
  const isFirstPathname = useRef(true);

  useEffect(() => {
    initPostHogOnce();
  }, []);

  useEffect(() => {
    if (isFirstPathname.current) {
      // The initial pageview (and its `surface` stamp) is handled inside
      // initPostHogOnce's loaded callback — only track navigations here.
      isFirstPathname.current = false;

      return;
    }

    if (pathname) trackSpaNavigation(pathname);
  }, [pathname]);

  return null;
}
